module.exports = __webpack_public_path__ + "assets/media/bar-graph.6f761a1b.svg";